import { store } from 'quasar/wrappers';
import { createPinia } from 'pinia';
import type { Router } from 'vue-router';
//
import { createPersistedStatePlugin } from 'pinia-plugin-persistedstate-2';
//
/*
 * When adding new properties to stores, you should also
 * extend the `PiniaCustomProperties` interface.
 * @see https://pinia.vuejs.org/core-concepts/plugins.html#typing-new-store-properties
 */
declare module 'pinia' {
  export interface PiniaCustomProperties {
    readonly router: Router;
  }
}

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default store((/* { ssrContext } */) => {
  const pinia = createPinia();

  // You can add Pinia plugins here
  // pinia.use(SomePiniaPlugin)

  // NOTE: 20240816-1301: BEFORE
  // pinia.use(createPersistedStatePlugin());
  // NOTE: 20240816-1301: https://www.npmjs.com/package/pinia-plugin-persistedstate-2 - Usage:
  // All you need to do is add the plugin to pinia:
  // import { createPinia } from 'pinia'
  // import { createPersistedStatePlugin } from 'pinia-plugin-persistedstate-2'
  // const pinia = createPinia()
  // const installPersistedStatePlugin = createPersistedStatePlugin()
  // pinia.use((context) => installPersistedStatePlugin(context))

  const loInstallPersistdStatePlugin = createPersistedStatePlugin();
  pinia.use((poContext) => loInstallPersistdStatePlugin(poContext));

  return pinia;
});
